const filterInitiativesByActuals = (initiative, value, key) => {
  const hasImpact = Array.isArray(initiative.impact) && initiative.impact.length > 0;
  let category = '<not set>';

  const isBelowL3 = ['L0', 'L1', 'L2'].includes(initiative.stage);
  const isInactiveStatus = ['On Hold', 'Cancelled', 'Rejected'].includes(initiative.weeklyStatus);

  if (isBelowL3 || isInactiveStatus) {
    category = 'No actuals (below L3 or cancelled/on hold)';
  } else {
    // Calculate current month and year indexes (relative to July 2023 = index 0)
    const calculateCurrentIndexes = () => {
      const startYear = 2023;
      const startMonth = 6; // July is month 6 (0-based)
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();
      const currentMonthIndex = (currentYear - startYear) * 12 + (currentMonth - startMonth);
      const currentYearIndex = currentYear - startYear;
      return { currentMonthIndex, currentYearIndex };
    };

    const { currentMonthIndex, currentYearIndex } = calculateCurrentIndexes();

    // Calculate FY25-26 year index dynamically (FY starts in July 2025)
    const fy2526YearIndex = 2025 - 2023; // 2025 - 2023 = 2

    const validKeys = {
      '(FY23-24) Actual impact update check': { startMonthIndex: 0, endMonthIndex: 11, fyLabel: 'FY 23-24', yearIndex: 0 },
      '(FY24-25) Actual impact update check': { startMonthIndex: 12, endMonthIndex: 23, fyLabel: 'FY 24-25', yearIndex: 1 },
      '(FY25-26) Actual impact update check': { startMonthIndex: 24, endMonthIndex: 35, fyLabel: 'FY 25-26', yearIndex: fy2526YearIndex },
      '(FY26-27) Actual impact update check': { startMonthIndex: 36, endMonthIndex: 47, fyLabel: 'FY 26-27', yearIndex: 3 },
      '(FY27-28) Actual impact update check': { startMonthIndex: 48, endMonthIndex: 59, fyLabel: 'FY 27-28', yearIndex: 4 }
    };

    const targetKeyData = validKeys[key];
    if (!targetKeyData) {
      category = '<not set>';
    } else if (!hasImpact || !initiative.hasFinancialImpact) {
      category = 'No actuals required or no impacts';
    } else {
      const { startMonthIndex, endMonthIndex, fyLabel, yearIndex } = targetKeyData;
      let hasValidPlanInTargetFy = false;
      let allPlansHaveActuals = true;

      // For FY25-26, only check up to the last completed month
      let effectiveEndMonthIndex = endMonthIndex;

      if (key === '(FY25-26) Actual impact update check') {
        // Only check months that have been completed (up to the start month index)
        effectiveEndMonthIndex = Math.min(startMonthIndex, currentMonthIndex);
      } else if (currentMonthIndex < startMonthIndex) {
        // We haven't reached this fiscal year yet
        category = 'No actuals required or no impacts';
      } else if (currentMonthIndex < endMonthIndex) {
        // We're in the middle of this fiscal year, check only up to current month
        effectiveEndMonthIndex = Math.min(currentMonthIndex, endMonthIndex);
      }

      // Skip checking if we haven't reached this fiscal year or for FY25-26 future months
      if (category === 'No actuals required or no impacts' && currentMonthIndex < startMonthIndex) {
        // category already set above
      } else if (key === '(FY25-26) Actual impact update check' && currentMonthIndex < startMonthIndex) {
        // FY25-26 hasn't started yet
        category = 'No actuals required or no impacts';
      } else {
        for (const imp of initiative.impact) {
          // Check monthly plans for the target FY up to effective end month
          if (Array.isArray(imp.monthlyPlan) && imp.monthlyPlan.length > effectiveEndMonthIndex) {
            // Check all months in the target FY up to effective end month
            for (let monthIndex = startMonthIndex; monthIndex <= effectiveEndMonthIndex; monthIndex++) {
              const planValue = imp.monthlyPlan[monthIndex];
              // Consider 0 as a valid plan value
              if (planValue !== null && planValue !== undefined) {
                hasValidPlanInTargetFy = true;

                // Check if there's a corresponding actual for this month
                if (Array.isArray(imp.monthlyActual) && imp.monthlyActual.length > monthIndex) {
                  const actualValue = imp.monthlyActual[monthIndex];
                  // If plan exists but actual is missing (null, undefined, but NOT 0), mark as incomplete
                  if (actualValue === null || actualValue === undefined) {
                    allPlansHaveActuals = false;
                    break; // Found a missing actual, no need to check further months
                  }
                } else {
                  // monthlyActual array doesn't exist or doesn't have enough elements
                  allPlansHaveActuals = false;
                  break;
                }
              }
            }
            // If we found a missing actual in this impact, no need to check other impacts
            if (!allPlansHaveActuals) {
              break;
            }
          }
        }
        if (!hasValidPlanInTargetFy) {
          category = 'No actuals required or no impacts';
        } else if (hasValidPlanInTargetFy && !allPlansHaveActuals) {
          category = `Missing actual in ${fyLabel}`;
        } else if (hasValidPlanInTargetFy && allPlansHaveActuals) {
          category = `Filled actual in ${fyLabel}`;
        } else {
          category = '<not set>';
        }
      }
    }
  }
  return value.includes(category);
};
export default filterInitiativesByActuals;